import Collapsible from "react-collapsible";
import "./styles.scss";

interface FaqsItemProps {
  item: {
    title: string;
    text: string;
    defaultOpen?: boolean;
  };
  compact?: boolean;
}

const FaqsItem = ({ item, compact }: FaqsItemProps) => {
  return (
    <Collapsible
      trigger={item.title}
      className={`${compact ? "Faq-item Faq-item--compact" : "Faq-item"}`}
      openedClassName={`${compact ? "Faq-item Faq-item--compact" : "Faq-item"}`}
      triggerClassName="Faq-item__title"
      triggerOpenedClassName="Faq-item__title"
      contentInnerClassName="Faq-item__content"
      transitionTime={200}
      triggerTagName="div"
      open={item.defaultOpen}>
      <span
        className="Faq-content"
        dangerouslySetInnerHTML={{ __html: item.text }}
      />
    </Collapsible>
  );
};

export default FaqsItem;
